/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import PaisForm from './PaisForm';
import * as validations from '../../validations/validations';
import * as paisActions from '../../actions/paisActions';
import * as userActions from '../../actions/userActions';
import {  useParams } from "react-router-dom";
import {  useLocation, useNavigate  } from "react-router-dom";
import * as paginaActions from '../../actions/paginaActions';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import { Segment} from 'semantic-ui-react';
import {genericFormattedForDropdown} from '../../selectors/selectors';
import moment from 'moment';
import {getMargenes, usuarioActual} from '../../util/';
 import $ from 'jquery';


class ManagePaisForm extends React.Component {

    constructor(props, context){
		super(props, context);
		this.state={
            errors:{},
            permisos:{},
			pais:{
                    }
		};
		
	}
    
    
    componentDidMount(){
        
        let id=this.props.id;
        /*
        let pageInfo={ 
            page:'pais', 
            idioma:this.props.idioma     
        }; 
   this.props.showSidebarIzquierdaActions.sidebarIzquierda(true);  
       this.props.paginaActions.getInfo(pageInfo, this.props.user).then( pageInfoResponse=>{ 
           this.setState({"permisos":pageInfoResponse.permisos, 
                         "strings":Object.assign({}, pageInfoResponse.strings)}); 
       }) 
        .catch(error=>{ 
          toastr.error(error); 
        }); 
        
        */
        
        usuarioActual(this, "pais",true).then( (usuario)=>{
        
            if(id && id>0 ){

               this.props.paisActions.getPais(id, usuario).then( pais=>{
                   this.setState({"pais":pais});
               })
                .catch(error=>{
                  toastr.error(error);
                }); 
            }
        
		 })
        .catch(error=>{
          toastr.error(error);
        });
    }
    

    handleChange=(event, data)=> {

        let pais = this.state.pais;
        let field= data.name;		
        let value;
    
        if(data.type == 'radio'){
            value=	data.checked;		
        }else{
            value=	data.value;		
        }
        
        if(data.toggle){
            if(data.checked){
                value = 1;
            }else{
                 value = 2
            }
        }
        
        
        field=field.split('.');
		if(field.length==1)
      		pais[field[0]]= value;
		else{
             if(!pais[field[0]]){
                    pais[field[0]]={}
                }
			pais[field[0]][field[1]]= value;
		}
        
		
        this.setState({"pais": pais});
    }
    
    
    FormIsValid(){
        let formIsValid=true;
        let falla="";
        let errors={};
            
        let pais=this.state.pais;
              
        if(!validations.requerido(pais.descripcion)){
            errors.descripcion=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(pais.codigoIso)){
            errors.codigoIso=true;
            formIsValid=false;
        }
      
        
        this.setState({
            "errors":errors
        });
        
        if(!formIsValid){
			toastr.error("Debes capturar la información requerida.");
        }
    
        return formIsValid;
    }



    onSave=(event)=>{
        event.preventDefault();
        if(!this.FormIsValid()){
            return ;
        }
       
        
        this.props.paisActions.save(this.state.pais, this.props.user).then(() => {
            toastr.success("Registro guardado!!!.");
            this.props.navigate(-1);
        });
        
    }

       
    render() {	
          
   let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		 		return (
              <Segment  style={margenes}>
                <PaisForm 
                    strings={this.state.strings}
                    id={this.props.id}
                    onChange={this.handleChange}
                    errors={this.state.errors}
                    datos={this.state.pais}
                    onSave={this.onSave}      
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    color={this.props.color}
                    form={this.props.form}
                    permisos={this.state.permisos}
                    
                />

            </Segment> 
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){
    
        
    return {        
        ajaxCallInProgress:state.ajaxCallInProgress,
        
        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda, 
        color:state.color,
        user:state.user, 
        idioma:state.idioma,
        form:state.form
    }

}

function mapDispatchToProps(dispatch){

	return {   
        showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
        paginaActions: bindActionCreators(paginaActions, dispatch),
        paisActions: bindActionCreators(paisActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch)
	};
}

function Parametros(){
    const {id} = useParams();
    const location = useLocation();
    return{
        id
    }
}

export default connect (mapStateToProps, mapDispatchToProps)(ManagePaisForm);